import script from "./subsidiary.vue?vue&type=script&lang=ts&setup=true"
export * from "./subsidiary.vue?vue&type=script&lang=ts&setup=true"

import "./subsidiary.vue?vue&type=style&index=0&id=47f6c8de&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f6c8de"]])

export default __exports__